/**
 * @desc pageListByQueryBody
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierSn.pageListByQueryBody.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/pageListByQueryBody`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
